// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  height: 100%;
}

ion-img {
  width: 50px;
}

ul {
  list-style-type: none;
  padding: 0px;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
  text-decoration: none;
}
li .wrapper {
  padding: 17px 20px;
  background: white;
  width: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
li .wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .wrapper .info_block p {
  padding: 0px 10px;
  color: var(--text-color);
  font-family: AppFontBold, sans-serif;
}
li .wrapper .info_block ion-img {
  width: 30px;
  height: 30px;
}
li .wrapper .circle {
  width: 30px;
  height: 30px;
  content: " ";
  border: 2px solid var(--ion-color-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
li .wrapper .circle .cirle_inner {
  width: 22px;
  height: 22px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .wrapper .circle .cirle_inner.selected {
  background: var(--ion-color-primary);
  border-radius: 50;
  transition: ease-in-out 0.3s;
}

.line-border {
  padding: 0px 20px;
}
.line-border ion-icon {
  fill: white;
  width: 100%;
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-language-popover/select-language-popover.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EAEA,YAAA;AAAJ;;AAEA;EACI,WAAA;AACJ;;AACA;EACI,qBAAA;EACA,YAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAEJ;AAAI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAER;AADQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;AAGZ;AAFY;EACI,iBAAA;EACA,wBAAA;EACA,oCAAA;AAIhB;AAFY;EACI,WAAA;EACA,YAAA;AAIhB;AADQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGZ;AADY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAGhB;AAFgB;EACI,oCAAA;EACA,iBAAA;EACA,4BAAA;AAIpB;;AAEA;EACI,iBAAA;AACJ;AAAI;EACI,WAAA;EACA,WAAA;AAER;;AACA;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAEJ;AADI;EACI,WAAA;AAGR","sourcesContent":[".wrapper{\n    width: 100%;\n\n    height: 100%;\n}\nion-img {\n    width: 50px;\n}\nul {\n    list-style-type: none;\n    padding: 0px;\n\n}\nli {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 20px;\n    text-decoration: none;\n  \n    .wrapper {\n        padding: 17px 20px;\n        background: white;\n        width: 100%;\n        border-radius: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        cursor: pointer;\n        .info_block {\n            border-radius: 20px;\n            display: flex;\n            align-items: center;\n            p {\n                padding: 0px 10px;\n                color: var(--text-color);\n                font-family: AppFontBold, sans-serif;\n            }\n            ion-img {\n                width: 30px;\n                height: 30px;\n            }\n        }\n        .circle {\n            width: 30px;\n            height: 30px;\n            content: ' ';\n            border: 2px solid var(--ion-color-primary);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          \n            .cirle_inner {\n                width: 22px;\n                height: 22px;\n                content: ' ';\n                background: transparent;\n                border-radius: 50%;\n                &.selected {\n                    background: var(--ion-color-primary);\n                    border-radius: 50;\n                    transition: ease-in-out 0.3s;\n                }\n            }\n        }\n    }  \n}\n.line-border {\n    padding: 0px 20px;\n    ion-icon {\n        fill: white;\n        width: 100%;\n    }\n}\n.footer-item {\n    position: fixed;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    padding: 20px;\n    display: flex;\n    justify-content: center;\n    ion-button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
